import React from "react";
import {
  NotificationsOutlined,
  Brightness4,
  AutoAwesome,
  Person,
  HelpOutline,
  ReceiptLongOutlined,
  AdminPanelSettings,
  Logout,
  AssignmentOutlined,
  SpaceDashboardOutlined,
  AccessTimeOutlined,
} from "@mui/icons-material";

/**
 * Definições do Topbar para uso em guias (ex.: /help).
 * Não controla renderização do Topbar — é apenas um “mapa” com ordem e gating.
 */
export const topbarHelpItems = [
  {
    key: "notifications",
    label: "Notificações",
    icon: <NotificationsOutlined />,
    kind: "action",
    visible: () => true,
  },
  {
    key: "themes",
    label: "Temas (aparência)",
    icon: <Brightness4 />,
    kind: "action",
    visible: () => true,
  },
  {
    key: "platform_ai",
    label: "Assistente da plataforma (IA)",
    icon: <AutoAwesome />,
    kind: "action",
    visible: () => true,
  },
  {
    key: "profile_menu",
    label: "Menu do perfil",
    icon: <Person />,
    kind: "group",
    visible: () => true,
    children: [
      {
        key: "my_profile",
        label: "Meu perfil",
        icon: <Person fontSize="small" />,
        kind: "route",
        route: "/profile",
        visible: () => true,
      },
      {
        key: "my_time_clock",
        label: "Meu Ponto",
        icon: <AccessTimeOutlined fontSize="small" />,
        kind: "route",
        route: "/meu-ponto",
        visible: ({ canViewTimeClock }) => Boolean(canViewTimeClock),
      },
      {
        key: "my_tasks",
        label: "Minhas tarefas",
        icon: <AssignmentOutlined fontSize="small" />,
        kind: "action",
        visible: () => true,
      },
      {
        key: "cockpit",
        label: "Cockpit",
        icon: <SpaceDashboardOutlined fontSize="small" />,
        kind: "action",
        visible: () => true,
      },
      {
        key: "help_training",
        label: "Ajuda e Treinamento",
        icon: <HelpOutline fontSize="small" />,
        kind: "action",
        visible: () => true,
      },
      {
        key: "product_guide",
        label: "Guia completo",
        icon: <HelpOutline fontSize="small" />,
        kind: "route",
        route: "/help",
        visible: () => true,
      },
      {
        key: "billing",
        label: "Plano e faturamento",
        icon: <ReceiptLongOutlined fontSize="small" />,
        kind: "route",
        route: "/settings/billing",
        visible: ({ canViewBilling }) => Boolean(canViewBilling),
      },
      {
        key: "platform_console",
        label: "Console da plataforma",
        icon: <AdminPanelSettings fontSize="small" />,
        kind: "route",
        route: "/platform/xprobase",
        visible: ({ isPlatformAdmin }) => Boolean(isPlatformAdmin),
      },
      {
        key: "partner_console",
        label: "Portal do parceiro",
        icon: <AdminPanelSettings fontSize="small" />,
        kind: "route",
        route: "/partner/console",
        visible: ({ isPartnerUser }) => Boolean(isPartnerUser),
      },
      {
        key: "logout",
        label: "Sair",
        icon: <Logout fontSize="small" />,
        kind: "action",
        visible: () => true,
      },
    ],
  },
];

